import "@/styles/main.scss";

import App from "@/App";
import { GlobalProvider } from "@/containers/global";
import { Web3AuthProvider } from "@/containers/global/Web3AuthProvider";
import { I18nProvider } from "@/shared/i18n";
import { store } from "@/store";
import { configureExplorer } from "@filedgr/web-core/explorer";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";

const useMocks = import.meta.env.VITE_USE_MOCKS === "true";

// web-core never reads `import.meta.env` (it has to work outside Vite too), so
// the explorer base is injected here, once, before anything can build a link.
// An unset variable leaves web-core's own default, `explorer.filedgr.network`.
configureExplorer({ baseUrl: import.meta.env.VITE_EXPLORER_URL });

const render = () => {
  const container = document.getElementById("root");
  if (!container) throw new Error('Missing #root element in index.html');

  createRoot(container).render(
    <StrictMode>
      <Provider store={store}>
        <I18nProvider>
          <Web3AuthProvider>
            {/* Mirrors the Web3Auth session into redux. Renders nothing. */}
            <GlobalProvider />
            <App />
          </Web3AuthProvider>
        </I18nProvider>
      </Provider>
    </StrictMode>
  );
};

const bootstrap = async () => {
  // The worker must be listening before the first request goes out, so this
  // is awaited ahead of render rather than fired alongside it.
  if (useMocks) {
    const { startMockWorker } = await import("@/mocks/browser");
    await startMockWorker();
  }
  render();
};

void bootstrap();
